import { initTracing } from '@rtvloco/otel';
import { getEnv } from '@rtvloco/platform/env';

/**
 * Initialize browser tracing for this SPA. Idempotent — safe to call multiple times.
 *
 * MUST be called AFTER `await loadConfig()` so /config.json values are resolvable
 * via getEnv(). All config flows through the canonical runtime-config pathway:
 *   /config.json → loadConfig() → getEnv()
 *
 * No direct window.__ENV__ or import.meta.env access — getEnv() owns that resolution.
 */
export function initAppTracing(): void {
  initTracing({
    serviceName: 'sentinel-web',
    serviceVersion: getEnv('appVersion', '0.0.0'),
    environment: getEnv('environment', 'local'),
    collectorUrl: getEnv('otelCollectorUrl', '/otel/v1/traces'),
  });
}
